import encryptServer from '../request/encryptRequest.js';

export const cooperationSubscriptionPageList = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/cooperationSubscription/pageList', params);

export const cooperationSubscriptionSubscribe = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/cooperationSubscription/subscribe', params);

export const cooperationSubscriptionCancel = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/cooperationSubscription/cancel', params);

export const cooperationEnterprisePageList = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/cooperationEnterprise/pageList', params);

export const cooperationEnterpriseClose = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/cooperationEnterprise/close', params);

export const cooperationEnterpriseOpen = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/cooperationEnterprise/open', params);

// 查询配置
export const getConfig = (clientType) => encryptServer.post('xiaozi-xmo/wireless/saas/task/cooperation/config/getConfig', { clientType });

// 重置配置
export const resetConfig = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/task/cooperation/config/reset', params);

// 保存配置
export const saveConfig = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/task/cooperation/config/save', params);

// 查询分类和数量
export const getCategoryAndCount = (clientType) => encryptServer.post('/xiaozi-xmo/wireless/saas/task/cooperation/getCategoryAndCount', { clientType });

// 不再提醒
export const noAlert = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/task/cooperation/noAlert', params);

// 任务分页列表
export const taskPageList = (params) => encryptServer.post('/xiaozi-xmo/wireless/saas/task/cooperation/pageList', params);
